<template>
  <router-link
    class="flex flex-no-shrink p-4 mb-1 px-8 cursor-pointer no-underline text-white hover:bg-gray-800"
    :to="route"
  >
    <div class="mr-4 w-4">
      <font-awesome-icon :icon="icon"></font-awesome-icon>
    </div>

    <div>
      <slot></slot>
    </div>
  </router-link>
</template>

<script>
export default {
  props: ["icon", "to"],

  computed: {
    route() {
      if (this.to == undefined) {
        return { name: "" };
      } else if (this.to != null && typeof this.to === "object") {
        return this.to;
      } else {
        return { name: this.to };
      }
    }
  }
};
</script>
